import { watch } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { useGridStore } from '@/stores/grid';
import { useSheetsStore } from '@/stores/sheets';
import { useDictionariesStore } from '@/stores/dictionaries';
import { useObservation } from './useObservation';

/** Подготавливаем вторую большую таблицу после открытия первой. Только в памяти сессии. */
export function useTablePreload(): void {
  const route = useRoute();
  const auth = useAuthStore();
  const grid = useGridStore();
  const sheets = useSheetsStore();
  const dictionaries = useDictionariesStore();
  const observation = useObservation();
  watch(() => {
    if (!auth.isAuthenticated || observation.active.value) return null;
    if (['grid', 'candidate'].includes(String(route.name)) && grid.initialised && !grid.loading
      && !sheets.detail && !sheets.loading && !sheets.error && sheets.sheets.some(sheet => sheet.code === 'base')) return 'base';
    if (route.name === 'sheet' && sheets.hasLoadedRows(String(route.params.code))
      && !grid.initialised && !grid.loading && !grid.refreshing && !grid.error) return 'grid';
    return null;
  }, (target, _previous, onCleanup) => {
    if (!target) return;
    // Два кадра дают текущей таблице появиться до чтения соседней.
    let second = 0;
    const first = requestAnimationFrame(() => {
      second = requestAnimationFrame(() => {
        if (target === 'base') {
          void import('@/views/SheetView.vue').catch(() => {});
          void sheets.enter('base');
        } else {
          void import('@/views/GridView.vue').catch(() => {});
          void dictionaries.loadAll().catch(() => {});
          void grid.enter();
        }
      });
    });
    onCleanup(() => { cancelAnimationFrame(first); cancelAnimationFrame(second); });
  }, { immediate: true, flush: 'post' });
}
